import { billsApi } from '@/api/apiClients';

export const deleteBillAndPayment = (billId: string) =>
  billsApi.deleteBillsBillId({ id: billId }).then((res) => res.data.deleted);
